<template>
  <div class="timeline">
    <event
      v-for="event in filteredEvents"
      :event="event"
      :key="event.id"
      :showNewCircle="showNewCircle"
    ></event>
  </div>
</template>

<script>
import Event from "./Event";

export default {
  name: "Timeline",
  props: ["events", "book", "showNewCircle", "friends"],
  components: { Event },
  data: function () {
    return {};
  },
  computed: {
    filteredEvents() {
      return filterEventsForBook(this.events, this.book, this.friends);
    },
  },
};

function filterEventsForBook(events, book, friends) {
  if (friends) {
    const filteredEvents = [];
    for (const e in events) {
      const event = events[e];
      if (event.content.indexOf("Your friend") !== -1) {
        filteredEvents.push(event);
      }
    }
    return filteredEvents;
  }

  if (!book) {
    return events;
  }

  const bookTitle = truncateString(book.title, 31);
  //const bookTitle = book.title;
  const filteredEvents = [];
  for (const e in events) {
    const event = events[e];
    // console.log(
    //   "bookCheck",
    //   event.content.indexOf(bookTitle),
    //   bookTitle,
    //   event.content
    // );
    if (event.content.indexOf(bookTitle) !== -1) {
      filteredEvents.push(event);
    }
  }

  return filteredEvents;
}

function truncateString(str, num) {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num);
}
</script>

<style lang="scss" scoped>
</style>

